import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonBack from '../../../components/Editor/ButtonBack';
import Utils from '../../../utils';

const mapStateToProps = (state: StoreState) => {
	const {
		routerParamsHistory,
		driveList,
		galleryInfos: { config },
	} = state;
	const { params: { resourceId } } = routerParamsHistory[routerParamsHistory.length - 1];
	const driveItem = driveList.driveItems[resourceId];

	return {
		parentId: driveItem
			? driveItem.parent
			: Utils.getPrivateDirId(driveList, config),
	};
};

export default connect(mapStateToProps)(ButtonBack);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonBack/index.tsx